"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialProtocolParamsToJson = exports.defaultProtocolParameters = exports.partialProtocolParametersFromCborObj = exports.partialProtocolParametersToData = exports.partialProtocolParametersToCborObj = exports.isPartialProtocolParameters = exports.isProtocolParameters = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var ints_1 = require("../../utils/ints.js");
var cardano_costmodels_ts_1 = require("@harmoniclabs/cardano-costmodels-ts");
var plutus_machine_1 = require("@harmoniclabs/plutus-machine");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var Rational_1 = require("./Rational.js");
var PParamsPoolVotingThresholds_1 = require("./PParamsPoolVotingThresholds.js");
var PParamsDrepVotingThresholds_1 = require("./PParamsDrepVotingThresholds.js");
var protocolVersion_1 = require("./protocolVersion.js");
var plutus_data_1 = require("@harmoniclabs/plutus-data");
var uint8array_utils_1 = require("@harmoniclabs/uint8array-utils");
function isProtocolParameters(something) {
    var expectedKeys = [
        "txFeePerByte",
        "txFeeFixed",
        "maxBlockBodySize",
        "maxTxSize",
        "maxBlockHeaderSize",
        "stakeAddressDeposit",
        "stakePoolDeposit",
        "poolRetireMaxEpoch",
        "stakePoolTargetNum",
        "poolPledgeInfluence",
        "monetaryExpansion",
        "treasuryCut",
        // protocolVersion removed in conway
        // "protocolVersion",
        "minPoolCost",
        "utxoCostPerByte",
        "costModels",
        "executionUnitPrices",
        "maxTxExecutionUnits",
        "maxBlockExecutionUnits",
        "maxValueSize",
        "collateralPercentage",
        "maxCollateralInputs",
        "poolVotingThresholds",
        "drepVotingThresholds",
        "minCommitteSize",
        "committeeTermLimit",
        "governanceActionValidityPeriod",
        "governanceActionDeposit",
        "drepDeposit",
        "drepActivityPeriod",
        "minfeeRefScriptCostPerByte"
    ];
    var actualKeys = Object.keys(something);
    if (!expectedKeys.every(function (k) { return actualKeys.includes(k); }))
        return false;
    var pp = something;
    if (![
        "txFeePerByte",
        "txFeeFixed",
        "maxBlockBodySize",
        "maxTxSize",
        "maxBlockHeaderSize",
        "stakeAddressDeposit",
        "stakePoolDeposit",
        "poolRetireMaxEpoch",
        "stakePoolTargetNum",
        "minPoolCost",
        "utxoCostPerByte",
        "maxValueSize",
        "collateralPercentage",
        "maxCollateralInputs",
        "minCommitteSize",
        "committeeTermLimit",
        "governanceActionValidityPeriod",
        "governanceActionDeposit",
        "drepDeposit",
        "drepActivityPeriod"
    ].every(function (uintKey) { return (0, ints_1.canBeUInteger)(pp[uintKey]); }))
        return false;
    if (!((0, Rational_1.isRational)(pp.poolPledgeInfluence) &&
        (0, Rational_1.isRational)(pp.monetaryExpansion) &&
        (0, Rational_1.isRational)(pp.treasuryCut) &&
        (0, Rational_1.isRational)(pp.minfeeRefScriptCostPerByte)))
        return false;
    var ppv = pp.protocolVersion;
    if (!(
    // protocolVersion removed in conway
    ppv === undefined ||
        (0, protocolVersion_1.isIProtocolVersion)(ppv)))
        return false;
    var ppexecCosts = pp.executionUnitPrices;
    if (!((Array.isArray(ppexecCosts) &&
        ppexecCosts.length >= 2 &&
        ppexecCosts[0] instanceof cbor_1.CborPositiveRational &&
        ppexecCosts[1] instanceof cbor_1.CborPositiveRational) ||
        ((0, obj_utils_1.isObject)(ppexecCosts) &&
            typeof ppexecCosts.priceSteps === "number" &&
            typeof ppexecCosts.priceMemory === "number")))
        return false;
    if (!(pp.maxTxExecutionUnits instanceof plutus_machine_1.ExBudget || plutus_machine_1.ExBudget.isJson(pp.maxTxExecutionUnits) &&
        pp.maxBlockExecutionUnits instanceof plutus_machine_1.ExBudget || plutus_machine_1.ExBudget.isJson(pp.maxBlockExecutionUnits)))
        return false;
    if (!((0, cardano_costmodels_ts_1.isCostModels)(pp.costModels) &&
        (0, PParamsPoolVotingThresholds_1.isPParamsPoolVotingThresholds)(pp.poolVotingThresholds) &&
        (0, PParamsDrepVotingThresholds_1.isPParamsDrepVotingThresholds)(pp.drepVotingThresholds)))
        return false;
    return true;
}
exports.isProtocolParameters = isProtocolParameters;
function isPartialProtocolParameters(something) {
    if (!(0, obj_utils_1.isObject)(something))
        return false;
    var pp = something;
    if (![
        "txFeePerByte",
        "txFeeFixed",
        "maxBlockBodySize",
        "maxTxSize",
        "maxBlockHeaderSize",
        "stakeAddressDeposit",
        "stakePoolDeposit",
        "poolRetireMaxEpoch",
        "stakePoolTargetNum",
        "minPoolCost",
        "utxoCostPerByte",
        "maxValueSize",
        "collateralPercentage",
        "maxCollateralInputs",
        "minCommitteSize",
        "committeeTermLimit",
        "governanceActionValidityPeriod",
        "governanceActionDeposit",
        "drepDeposit",
        "drepActivityPeriod"
    ].every(function (uintKey) { return pp[uintKey] === undefined || (0, ints_1.canBeUInteger)(pp[uintKey]); }))
        return false;
    if (!((0, Rational_1.isRationalOrUndefined)(pp.poolPledgeInfluence) &&
        (0, Rational_1.isRationalOrUndefined)(pp.monetaryExpansion) &&
        (0, Rational_1.isRationalOrUndefined)(pp.treasuryCut) &&
        (0, Rational_1.isRationalOrUndefined)(pp.minfeeRefScriptCostPerByte)))
        return false;
    var ppv = pp.protocolVersion;
    if (!(ppv === undefined ||
        (0, protocolVersion_1.isIProtocolVersion)(ppv)))
        return false;
    var ppexecCosts = pp.executionUnitPrices;
    if (!(ppexecCosts === undefined ||
        (Array.isArray(ppexecCosts) &&
            ppexecCosts.length >= 2 &&
            ppexecCosts[0] instanceof cbor_1.CborPositiveRational &&
            ppexecCosts[1] instanceof cbor_1.CborPositiveRational) || ((0, obj_utils_1.isObject)(ppexecCosts) &&
        typeof ppexecCosts.priceMemory === "number" &&
        typeof ppexecCosts.priceSteps === "number")))
        return false;
    if (!((pp.maxTxExecutionUnits === undefined ||
        pp.maxTxExecutionUnits instanceof plutus_machine_1.ExBudget ||
        plutus_machine_1.ExBudget.isJson(pp.maxTxExecutionUnits)) &&
        (pp.maxBlockExecutionUnits === undefined ||
            pp.maxBlockExecutionUnits instanceof plutus_machine_1.ExBudget ||
            plutus_machine_1.ExBudget.isJson(pp.maxBlockExecutionUnits))))
        return false;
    if (!((pp.costModels === undefined || (0, cardano_costmodels_ts_1.isCostModels)(pp.costModels)) &&
        (pp.poolVotingThresholds === undefined || (0, PParamsPoolVotingThresholds_1.isPParamsPoolVotingThresholds)(pp.poolVotingThresholds)) &&
        (pp.drepVotingThresholds === undefined || (0, PParamsDrepVotingThresholds_1.isPParamsDrepVotingThresholds)(pp.drepVotingThresholds))))
        return false;
    return true;
}
exports.isPartialProtocolParameters = isPartialProtocolParameters;
function mapUIntEntryOrUndefined(tag, a) {
    return a === undefined ? undefined : {
        k: new cbor_1.CborUInt(tag),
        v: new cbor_1.CborUInt((0, ints_1.forceBigUInt)(a))
    };
}
function fromUIntOrUndef(n) {
    return n instanceof cbor_1.CborUInt ? n.num : undefined;
}
function kv(k, v) {
    return v === undefined ? undefined : {
        k: new cbor_1.CborUInt(k),
        v: v
    };
}
function partialProtocolParametersToCborObj(pps) {
    var protocolVersion = pps.protocolVersion, executionUnitPrices = pps.executionUnitPrices, maxTxExecutionUnits = pps.maxTxExecutionUnits, maxBlockExecutionUnits = pps.maxBlockExecutionUnits, costModels = pps.costModels;
    var costModelsKeys = Object.keys(costModels !== null && costModels !== void 0 ? costModels : {});
    return new cbor_1.CborMap([
        mapUIntEntryOrUndefined(0, pps.txFeePerByte),
        mapUIntEntryOrUndefined(1, pps.txFeeFixed),
        mapUIntEntryOrUndefined(2, pps.maxBlockBodySize),
        mapUIntEntryOrUndefined(3, pps.maxTxSize),
        mapUIntEntryOrUndefined(4, pps.maxBlockHeaderSize),
        mapUIntEntryOrUndefined(5, pps.stakeAddressDeposit),
        mapUIntEntryOrUndefined(6, pps.stakePoolDeposit),
        mapUIntEntryOrUndefined(7, pps.poolRetireMaxEpoch),
        mapUIntEntryOrUndefined(8, pps.stakePoolTargetNum),
        kv(9, (0, Rational_1.tryCborFromRational)(pps.poolPledgeInfluence)),
        kv(10, (0, Rational_1.tryCborFromRational)(pps.monetaryExpansion)),
        kv(11, (0, Rational_1.tryCborFromRational)(pps.treasuryCut)),
        protocolVersion === undefined ? undefined :
            kv(14, (0, protocolVersion_1.protocolVersionToCborObj)(protocolVersion)),
        mapUIntEntryOrUndefined(16, pps.minPoolCost),
        mapUIntEntryOrUndefined(17, pps.utxoCostPerByte),
        kv(18, (costModels === undefined ||
            (!costModelsKeys.includes("PlutusV1") && !costModelsKeys.includes("PlutusV2"))) ?
            undefined :
            (0, cardano_costmodels_ts_1.costModelsToCborObj)(costModels)),
        executionUnitPrices === undefined ? undefined :
            kv(19, Array.isArray(executionUnitPrices) ?
                new cbor_1.CborArray(executionUnitPrices) :
                new cbor_1.CborArray([
                    cbor_1.CborPositiveRational.fromNumber(executionUnitPrices.priceSteps),
                    cbor_1.CborPositiveRational.fromNumber(executionUnitPrices.priceMemory),
                ])),
        kv(20, plutus_machine_1.ExBudget.isJson(maxTxExecutionUnits) ? plutus_machine_1.ExBudget.fromJson(maxTxExecutionUnits).toCborObj() : maxTxExecutionUnits === null || maxTxExecutionUnits === void 0 ? void 0 : maxTxExecutionUnits.toCborObj()),
        kv(21, plutus_machine_1.ExBudget.isJson(maxBlockExecutionUnits) ? plutus_machine_1.ExBudget.fromJson(maxBlockExecutionUnits).toCborObj() : maxBlockExecutionUnits === null || maxBlockExecutionUnits === void 0 ? void 0 : maxBlockExecutionUnits.toCborObj()),
        mapUIntEntryOrUndefined(22, pps.maxValueSize),
        mapUIntEntryOrUndefined(23, pps.collateralPercentage),
        mapUIntEntryOrUndefined(24, pps.maxCollateralInputs),
        pps.poolVotingThresholds ? kv(25, (0, PParamsPoolVotingThresholds_1.poolVotingThresholdsToCborObj)(pps.poolVotingThresholds)) : undefined,
        pps.drepVotingThresholds ? kv(26, (0, PParamsDrepVotingThresholds_1.drepVotingThresholdsToCborObj)(pps.drepVotingThresholds)) : undefined,
        mapUIntEntryOrUndefined(27, pps.minCommitteSize),
        mapUIntEntryOrUndefined(28, pps.committeeTermLimit),
        mapUIntEntryOrUndefined(29, pps.governanceActionValidityPeriod),
        mapUIntEntryOrUndefined(30, pps.governanceActionDeposit),
        mapUIntEntryOrUndefined(31, pps.drepDeposit),
        mapUIntEntryOrUndefined(32, pps.drepActivityPeriod),
        kv(33, (0, Rational_1.tryCborFromRational)(pps.minfeeRefScriptCostPerByte)),
    ].filter(function (elem) { return elem !== undefined; }));
}
exports.partialProtocolParametersToCborObj = partialProtocolParametersToCborObj;
function partialProtocolParametersToData(pps) {
    return cborToDataLitteral(partialProtocolParametersToCborObj(pps));
}
exports.partialProtocolParametersToData = partialProtocolParametersToData;
function cborToDataLitteral(cbor) {
    if (cbor instanceof cbor_1.CborPositiveRational) {
        return new plutus_data_1.DataConstr(0, [new plutus_data_1.DataI(cbor.num), new plutus_data_1.DataI(cbor.den)]);
    }
    if (cbor instanceof cbor_1.CborUInt || cbor instanceof cbor_1.CborNegInt) {
        return new plutus_data_1.DataI(cbor.num);
    }
    if (cbor instanceof cbor_1.CborBytes) {
        return new plutus_data_1.DataB(cbor.bytes);
    }
    if (cbor instanceof cbor_1.CborText) {
        return new plutus_data_1.DataB((0, uint8array_utils_1.fromUtf8)(cbor.text));
    }
    if (cbor instanceof cbor_1.CborArray) {
        return new plutus_data_1.DataList(cbor.array.map(cborToDataLitteral));
    }
    if (cbor instanceof cbor_1.CborMap) {
        return new plutus_data_1.DataMap(cbor.map.map(function (_a) {
            var k = _a.k, v = _a.v;
            return new plutus_data_1.DataPair(cborToDataLitteral(k), cborToDataLitteral(v));
        }));
    }
    if (cbor instanceof cbor_1.CborTag) {
        return cborToDataLitteral(cbor.data);
    }
    throw new Error("unsupported cbor for litteral data");
}
var maxProtocolParamsEntries = 33;
function partialProtocolParametersFromCborObj(cObj) {
    var _a;
    if (!(cObj instanceof cbor_1.CborMap))
        throw new Error("Invalid CBOR format for \"Partial<ProtocolParameters>\"");
    var fields = new Array(maxProtocolParamsEntries).fill(undefined);
    var _loop_1 = function (i) {
        var v = ((_a = cObj.map.find(function (_a) {
            var k = _a.k;
            return k instanceof cbor_1.CborUInt && Number(k.num) === i;
        })) !== null && _a !== void 0 ? _a : { v: undefined }).v;
        if (v === undefined)
            return "continue";
        fields[i] = v;
    };
    for (var i = 0; i <= maxProtocolParamsEntries; i++) {
        _loop_1(i);
    }
    var _b = __read(fields, 34), _minFeeCoeff = _b[0], _minFeeFix = _b[1], _maxBlockBodySize = _b[2], _maxTxSize = _b[3], _maxBlockHeaderSize = _b[4], _keyDep = _b[5], _poolDep = _b[6], _epoch = _b[7], _kParam = _b[8], _pledgeInfluence = _b[9], _expansionRate = _b[10], _treasureryGrowthRate = _b[11], _12 = _b[12], _13 = _b[13], _protocolVersion = _b[14], _15 = _b[15], _poolMinFee = _b[16], _adaPerUtxoByte = _b[17], _costmdls = _b[18], _execCosts = _b[19], _maxTxExecUnits = _b[20], _maxBlockExecUnits = _b[21], _maxValueSize = _b[22], _collatearalPerc = _b[23], _maxCollIns = _b[24], 
    // conway
    _poolVotingThresholds = _b[25], _drepVotingThresholds = _b[26], _minCommitteSize = _b[27], _committeeTermLimit = _b[28], _governanceActionValidityPeriod = _b[29], _governanceActionDeposit = _b[30], _drepDeposit = _b[31], _drepActivityPeriod = _b[32], _minfeeRefScriptCostPerByte = _b[33];
    var protocolVersion = (0, protocolVersion_1.tryIProtocolVersionFromCborObj)(_protocolVersion);
    var executionUnitPrices = undefined;
    if (_execCosts instanceof cbor_1.CborArray) {
        var mem_price = cbor_1.CborPositiveRational.fromCborObjOrUndef(_execCosts.array[0]);
        var cpu_price = cbor_1.CborPositiveRational.fromCborObjOrUndef(_execCosts.array[1]);
        executionUnitPrices = mem_price !== undefined && cpu_price !== undefined ? [mem_price, cpu_price] : undefined;
    }
    var _costModels = (0, cardano_costmodels_ts_1.costModelsFromCborObj)(_costmdls);
    return {
        txFeePerByte: fromUIntOrUndef(_minFeeCoeff),
        txFeeFixed: fromUIntOrUndef(_minFeeFix),
        maxBlockBodySize: fromUIntOrUndef(_maxBlockBodySize),
        maxTxSize: fromUIntOrUndef(_maxTxSize),
        maxBlockHeaderSize: fromUIntOrUndef(_maxBlockHeaderSize),
        stakeAddressDeposit: fromUIntOrUndef(_keyDep),
        stakePoolDeposit: fromUIntOrUndef(_poolDep),
        poolRetireMaxEpoch: fromUIntOrUndef(_epoch),
        stakePoolTargetNum: fromUIntOrUndef(_kParam),
        poolPledgeInfluence: cbor_1.CborPositiveRational.fromCborObjOrUndef(_pledgeInfluence),
        monetaryExpansion: cbor_1.CborPositiveRational.fromCborObjOrUndef(_expansionRate),
        treasuryCut: cbor_1.CborPositiveRational.fromCborObjOrUndef(_treasureryGrowthRate),
        protocolVersion: protocolVersion,
        minPoolCost: fromUIntOrUndef(_poolMinFee),
        utxoCostPerByte: fromUIntOrUndef(_adaPerUtxoByte),
        costModels: Object.keys(_costModels).length === 0 ? undefined : _costModels,
        executionUnitPrices: executionUnitPrices,
        maxTxExecutionUnits: _maxTxExecUnits === undefined ? undefined : plutus_machine_1.ExBudget.fromCborObj(_maxTxExecUnits),
        maxBlockExecutionUnits: _maxBlockExecUnits === undefined ? undefined : plutus_machine_1.ExBudget.fromCborObj(_maxBlockExecUnits),
        maxValueSize: fromUIntOrUndef(_maxValueSize),
        collateralPercentage: fromUIntOrUndef(_collatearalPerc),
        maxCollateralInputs: fromUIntOrUndef(_maxCollIns),
        poolVotingThresholds: (0, PParamsPoolVotingThresholds_1.tryGetPParamsPoolVotingThresholdsFromCborObj)(_poolVotingThresholds),
        drepVotingThresholds: (0, PParamsDrepVotingThresholds_1.tryGetPParamsDrepVotingThresholdsFromCborObj)(_drepVotingThresholds),
        minCommitteSize: fromUIntOrUndef(_minCommitteSize),
        committeeTermLimit: fromUIntOrUndef(_committeeTermLimit),
        governanceActionValidityPeriod: fromUIntOrUndef(_governanceActionValidityPeriod),
        governanceActionDeposit: fromUIntOrUndef(_governanceActionDeposit),
        drepDeposit: fromUIntOrUndef(_drepDeposit),
        drepActivityPeriod: fromUIntOrUndef(_drepActivityPeriod),
        minfeeRefScriptCostPerByte: (0, Rational_1.tryCborFromRational)(_minfeeRefScriptCostPerByte)
    };
}
exports.partialProtocolParametersFromCborObj = partialProtocolParametersFromCborObj;
exports.defaultProtocolParameters = (0, obj_utils_1.freezeAll)({
    txFeePerByte: 44,
    txFeeFixed: 155381,
    maxBlockBodySize: 73728,
    maxTxSize: 16384,
    maxBlockHeaderSize: 1100,
    stakeAddressDeposit: 2000000,
    stakePoolDeposit: 500000000,
    poolRetireMaxEpoch: 18,
    stakePoolTargetNum: 500,
    poolPledgeInfluence: new cbor_1.CborPositiveRational(3, 10),
    monetaryExpansion: new cbor_1.CborPositiveRational(3, 1000),
    treasuryCut: new cbor_1.CborPositiveRational(2, 10),
    protocolVersion: [8, 0],
    minPoolCost: 340000000,
    utxoCostPerByte: 34482,
    costModels: {
        PlutusScriptV1: cardano_costmodels_ts_1.defaultV1Costs,
        PlutusScriptV2: cardano_costmodels_ts_1.defaultV2Costs,
        PlutusScriptV3: cardano_costmodels_ts_1.defaultV3Costs
    },
    executionUnitPrices: [
        cbor_1.CborPositiveRational.fromNumber(0.0577),
        cbor_1.CborPositiveRational.fromNumber(0.0000721) // cpu
    ],
    maxTxExecutionUnits: new plutus_machine_1.ExBudget({ mem: 12500000, cpu: 10000000000 }),
    maxBlockExecutionUnits: new plutus_machine_1.ExBudget({ mem: 50000000, cpu: 40000000000 }),
    maxValueSize: 5000,
    collateralPercentage: 150,
    maxCollateralInputs: 3,
    poolVotingThresholds: {
        committeeNormal: cbor_1.CborPositiveRational.fromNumber(0.51),
        committeeNoConfidence: cbor_1.CborPositiveRational.fromNumber(0.51),
        hardForkInitiation: cbor_1.CborPositiveRational.fromNumber(0.51),
        motionNoConfidence: cbor_1.CborPositiveRational.fromNumber(0.51),
        securityRelevantVotingThresholds: cbor_1.CborPositiveRational.fromNumber(0.51)
    },
    drepVotingThresholds: {
        motionNoConfidence: cbor_1.CborPositiveRational.fromNumber(0.51),
        committeeNormal: cbor_1.CborPositiveRational.fromNumber(0.51),
        committeeNoConfidence: cbor_1.CborPositiveRational.fromNumber(0.51),
        updateConstitution: cbor_1.CborPositiveRational.fromNumber(0.51),
        hardForkInitiation: cbor_1.CborPositiveRational.fromNumber(0.51),
        ppNetworkGroup: cbor_1.CborPositiveRational.fromNumber(0.51),
        ppEconomicGroup: cbor_1.CborPositiveRational.fromNumber(0.51),
        ppTechnicalGroup: cbor_1.CborPositiveRational.fromNumber(0.51),
        ppGovGroup: cbor_1.CborPositiveRational.fromNumber(0.51),
        treasuryWithdrawal: cbor_1.CborPositiveRational.fromNumber(0.51)
    },
    minCommitteSize: 0,
    committeeTermLimit: 200,
    governanceActionValidityPeriod: 10,
    governanceActionDeposit: 1000000000,
    drepDeposit: 2000000,
    drepActivityPeriod: 20,
    minfeeRefScriptCostPerByte: cbor_1.CborPositiveRational.fromNumber(0.5)
});
function partialProtocolParamsToJson(pp) {
    var _a, _b, _c, _d, _e;
    return __assign(__assign({}, pp), { poolPledgeInfluence: typeof pp.poolPledgeInfluence === "number" ? pp.poolPledgeInfluence : (_a = pp.poolPledgeInfluence) === null || _a === void 0 ? void 0 : _a.toNumber(), monetaryExpansion: typeof pp.monetaryExpansion === "number" ? pp.monetaryExpansion : (_b = pp.monetaryExpansion) === null || _b === void 0 ? void 0 : _b.toNumber(), treasuryCut: typeof pp.treasuryCut === "number" ? pp.treasuryCut : (_c = pp.treasuryCut) === null || _c === void 0 ? void 0 : _c.toNumber(), costModels: pp.costModels === undefined ? undefined : (0, cardano_costmodels_ts_1.costModelsToJson)(pp.costModels), executionUnitPrices: Array.isArray(pp.executionUnitPrices) ?
            {
                priceSteps: pp.executionUnitPrices[1].toNumber(),
                priceMemory: pp.executionUnitPrices[0].toNumber()
            } :
            pp.executionUnitPrices, maxTxExecutionUnits: plutus_machine_1.ExBudget.isJson(pp.maxTxExecutionUnits) ? pp.maxTxExecutionUnits : (_d = pp.maxTxExecutionUnits) === null || _d === void 0 ? void 0 : _d.toJson(), maxBlockExecutionUnits: plutus_machine_1.ExBudget.isJson(pp.maxBlockExecutionUnits) ? pp.maxBlockExecutionUnits : (_e = pp.maxBlockExecutionUnits) === null || _e === void 0 ? void 0 : _e.toJson() });
}
exports.partialProtocolParamsToJson = partialProtocolParamsToJson;
